import { FormattedMessage } from 'react-intl';

interface IProps {
  onClose: () => void;
  onClick: () => void;
}

const PromotionCodeDeleteModal = ({ onClose, onClick }: IProps) => {
  return (
    <div className="fixed inset-0 w-full h-full bg-black/80 flex justify-center items-center z-[1000]">
      <div className="min-w-[570px] rounded-2xl bg-white text-center p-10 flex flex-col gap-10">
        <div className="flex flex-col gap-2">
          <h3 className="text-[30px] leading-9 font-extrabold">
            <FormattedMessage id="remove_your_promo_code" defaultMessage="Remove your promo code" />
          </h3>
          <h3 className="text-[20px] leading-6 font-medium">
            <FormattedMessage
              id="remove_promo_code_modal_desc"
              defaultMessage="You’ll lose the discount if you remove the code."
            />
          </h3>
        </div>
        <div className="flex gap-[12px]">
          <button
            className="flex-1 flex justify-center items-center h-[66px] rounded-[20px] bg-[#f2f2f2] text-[18px] font-bold data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white"
            onClick={onClose}
          >
            <FormattedMessage id="cancel" defaultMessage="Cancel" />
          </button>
          <button
            className="flex-1 flex justify-center items-center h-[66px] rounded-[20px] bg-[#f2f2f2] text-[18px] font-bold data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white"
            data-primary
            onClick={onClick}
          >
            <FormattedMessage id="remove" defaultMessage="Remove" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromotionCodeDeleteModal;
